/*
    OneQuickShop 2.0.0 Usage (Webpack)
    yang @onerockwell        
*/

// Import all dependencies here
import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';

import OneDrawerv2 from 'Modules/module-oneDrawerv2';
import ViewQuickShop from 'Views/view-quickShop';

// Define the Backbone View here (Optional)
let OneQuickShopView = Backbone.View.extend({

    initialize: function (settings) {
        console.log('init quickshop');

        var self = this;
        self.$body = self.$el;

        self.quickshop();
    },

    events: {},

    productSiblingsSort: function () {
        var self = this;
        const oneSize = $('.product-quickshop').data('size');
        const wrapper = $('.product-quickshop .sibling-product-container');
        const siblings = wrapper.find('.sibling-list.normalPrice .list-item[data-discount=false]');
        const normalPriceContainer = wrapper.find('#normalPrice');
        let activeSibling = siblings.filter('.list-item.active').first();
        if (activeSibling.length == 0) {
            activeSibling = siblings.first();
        }

        // if (siblings.length > 6 && !oneSize) {
        //     siblings.each(function(index) {
        //         if (index === 6) {
        //             $(this).addClass('show-more');
        //         }
        //         if (index > 6) {
        //             $(this).hide();
        //         }
        //     })
        // } else if (siblings.length > 20 && oneSize) {
        //     siblings.each(function(index) {
        //         if (index === 20) {
        //             $(this).addClass('show-more');
        //         }
        //         if (index > 20) {
        //             $(this).hide();
        //         }
        //     })
        // } 
        
        if (siblings.length > 0) {
            normalPriceContainer.text('$' + (activeSibling.data('price') / 100));
            $('.quickshop-wrapper .price-box').hide();
        } else {
            normalPriceContainer.text('');
            $('.quickshop-wrapper .price-box').hide();
        }

        var events = {
            'click .show-more' : function() {
                const productLink = $('.product-full a').prop("href");
                location.href = productLink;
            }
        }
        
        // Update and delegate adding events
        _.extend(self.events, events);
        self.delegateEvents();
    },

    quickshop: function(){
        var self = this;
        
        /*
            Possible trigger of this function are :
            1. Click on '.quick-shop-trigger' which has data-url or href attribute.
            2. Click on '.swatch-linked' in quickshop container, which has data-url or href attribute.
            3. Direct call with 'event' object and target url as param.
        */
        var quickshopCtl = function(e,url){
            e.stopPropagation();
            e.preventDefault();
            
            var $curr = $(e.currentTarget);
            
            if (url) {
                var url = ORW.utilities.updateUrlParam(url, 'view', 'quickshop');
            } else {
                var url = $curr.data('url') ? ORW.utilities.updateUrlParam($curr.data('url'), 'view', 'quickshop') : ORW.utilities.updateUrlParam($curr.attr('href'), 'view', 'quickshop');
            }

            // Check the URL & add full domain including 'www'
            // In order to avoid the 301 redirect issue
            if(!url.startsWith(`//${ORW.storeDomain}`)){
                var url = url.replace(/\/\//, '//www.');
            }

            console.log('[OneQuickShopv2] URL:',url);
            
            if (url == '#?view=quickshop') {
                // Skip the empty URL 
                return false;
            }
            
            if (self.$currentQuickshop) {
                self.$currentQuickshop.destroy();
            }
            
            $.ajax({
                async: true,
                type: 'GET',
                url: url,
                cache: true,
                error: function(err) { 
                    console.log(err);
                },
                success: function(html) {
                    var $productDetail = $(html).find('.product-quickshop');
                    var quickshopHtml = $productDetail[0].outerHTML;
                    $productDetail.remove();
                    
                    if (self.$currentModal) {
                        // Replace content html
                        self.$currentModal.$drawer.find('.product-quickshop').remove();
                        self.$currentModal.$drawer.find('.drawer-content').append(quickshopHtml);
                        self.$currentQuickshop = new ViewQuickShop({el: $('.product-quickshop .quickshop-wrapper')});
                    } else {
                        OneDrawerv2.init({
                            el: self.$body,
                            drawerContent: quickshopHtml,
                            drawerModalId: 'QuickShopDrawerModal',
                            triggerEvent: 'click',
                            triggerElem: '.quick-shop-hidden-trigger',
                            initCallback: function(){
                                self.$currentModal = this;
                                self.$currentModal.openDrawer();
                                ORW.utilities.mediaCheck(function () {
                                    // Desktop actions
                                }, function () {
                                    // Mobile actions
                                    // self.$currentModal.closeDrawer();
                                })
                            },
                            openCallback: function(){
                                self.$currentQuickshop = new ViewQuickShop({el: $('.product-quickshop .quickshop-wrapper')});
                            },
                            closeCallback: function(){
                                if (self.$currentModal) {
                                    self.$currentModal.destroy();
                                    self.$currentModal = false;
                                }
                            },
                            events: {
                                'ajax-reload-inner' : function(e,url){
                                    quickshopCtl(e,url);
                                },
                                // Currently, we use cleanup function to destory drawers from ORW.drawerStack
                                // This option relies on event listener to close quickshop modal
                                // 'click .add-to-cart-btn:not(.disabled)': function(e){
                                //     var $addToCartBtn = $(e.currentTarget);
                                //     var originalCaption = $addToCartBtn.find('.add-to-cart-text').text();
                                //     $addToCartBtn.find('.add-to-cart-text').addClass('added').text('Added to bag');
                                //     // ! Ask pat about proper drawer destruction.
                                //     // ? Note we have 2 versions of drawer so this has to be done right.
                                //     setTimeout(function(){
                                //         if (self.$currentModal) {
                                //             self.$currentModal.destroy();
                                //             self.$currentModal = false;
                                //         }
                                //     },1500);
                                //     setTimeout(function(){
                                //         $addToCartBtn.find('.add-to-cart-text').removeClass('added').text(originalCaption);
                                //     },6000);
                                // }
                            }
                        });
                    }
                },
                complete: function(xhr, status) {
                    if (status === 'success') {
                        self.productSiblingsSort();
                    }
                }
            });
        }

        var events = {
            'click .quick-shop-trigger' : quickshopCtl,
            'click .quick-shop-trigger-link' : quickshopCtl,
            'click .quickshop-wrapper .sibling-link' : quickshopCtl
        }
        
        // Update and delegate adding events
        _.extend(self.events, events);
        self.delegateEvents();
    },

    destroy: function() {
        var self = this;
        self.undelegateEvents();
    }
});


// Define the module here 
let OneQuickShopv2 = {
    init: function (settings) {
        if (!settings.el) {
            settings.el = $('body');
        }
        return new OneQuickShopView(settings);
    }
}

// Output the module
export default OneQuickShopv2;